import styles from "./index.module.scss";

export const MainLoader = () => <div className={styles.loader} />;
